
import React, { PureComponent } from 'react';
import BlurModal from '../../../../../../src/components/common/blur-modal';
import Button from '@dbk/ui-buttons';
import { FormattedMessage } from '@dbk-legacy/format';
import { Transactions } from '@dbk/ui-icons';
import Text from '@dbk/ui-text';
import { PALETTE } from '../../../constants';

const styles={
    paymentLimitModal:{
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'row',
        justifyContent:'center',
        marginBottom: '24px'
    },
    paymentLimitModalHeader:{
        color: '#EDF1F7',
        fontSize: '32px',
        lineHeight: '41px',
        marginRight:'10px'
    },
    paymentLimitMsg:{
        whiteSpace:"pre-line"
    }
};



export default class PaymentLimit extends PureComponent {

    constructor(props) {
        super(props);
        this.state={isActive:true};
    }
    closeMsg = () => {
        this.setState({isActive:false});
        this.props.disableAlert();
    }

    render() {
        const { isPaymentLimit :{DAILY:dailyAmount,WEEKLY:weeklyAmount,MONTHLY:monthlyAmount},messages} = this.props;
        const totalAmount=dailyAmount;

        return (
            <BlurModal
                visible={this.state.isActive}
                doneVisible={true}
                title={messages['app.user.profile.paymentLimitTitle']}
                onDone={() => this.closeMsg()}
            >
               <div style={styles.paymentLimitModal}>
                    <Text style={styles.paymentLimitModalHeader}>
                        {messages['app.common.pageHeader.Payments']}
                    </Text>
                    <Transactions width={40} height={40} color={PALETTE.primaryActive} />
               </div>

               <div style={styles.paymentLimitMsg} >
                <Text secondary>
                    {messages['app.user.profile.paymentLimitMsg']}
                </Text>
                </div>
                <div className="row">
                    <div className="large-6 large-centered medium-6 medium-centered small-6 small-centered pad-top-20 text-center">
                        <Button size={'normal'} onClick={() => this.closeMsg()} >
                             {messages['app.rmcallback.okMsg']}
                       </Button>
                    </div>
                </div>
            </BlurModal>
        );
    }
}
